import { createUseStyles, withTheme } from '@glu/theming';
import PropTypes from 'prop-types';
import React from 'react';
import Day from './Day';
import WeekDays from './WeekDays';
import styles from './Month.styles';
import getMonthData from '../../utils/getMonthData';

const useStyles = createUseStyles(styles);

const Month = ({
  dateMax,
  dateMin,
  handleDayClick,
  handleDayHover,
  head,
  htmlId,
  index,
  selectedEndDate,
  selectedStartDate,
  weekNumbers,
  ...rest
}) => {
  const classes = useStyles(rest);

  const calendar = getMonthData(head, rest);

  return (
    <table aria-labelledby={`${htmlId}-${index}-calendarHead`} className={classes.calendar}>
      <WeekDays weekNumbers={weekNumbers} />
      <tbody>
        {calendar.map(({ days, week }) => (
          <tr key={`week-${week}`} data-qa="calendar-row">
            {weekNumbers && (
              <td className={classes.weekCell}>
                <span>{week}</span>
              </td>
            )}
            {days.map((day) => (
              <Day
                dateMax={dateMax}
                dateMin={dateMin}
                {...rest}
                key={`day-${day}`}
                day={day}
                head={head}
                onClick={handleDayClick}
                onMouseEnter={handleDayHover}
                selectedEndDate={selectedEndDate}
                selectedStartDate={selectedStartDate}
              />
            ))}
          </tr>
        ))}
        {calendar.length < 6 && (
          <tr data-qa="calendar-row">
            <td className={classes.emptyWeekDay}>&nbsp;</td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

Month.propTypes = {
  dateMax: PropTypes.string.isRequired,
  dateMin: PropTypes.string.isRequired,
  handleDayClick: PropTypes.func.isRequired,
  handleDayHover: PropTypes.func.isRequired,
  head: PropTypes.shape({}).isRequired,
  htmlId: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  options: PropTypes.shape({}),
  selectedEndDate: PropTypes.shape({}),
  selectedStartDate: PropTypes.shape({}),
  weekNumbers: PropTypes.bool.isRequired,
};

Month.defaultProps = {
  options: {},
  selectedEndDate: undefined,
  selectedStartDate: undefined,
};

export default withTheme(Month);
